// Danh sách lệnh chạy (phân trang "Tải thêm"); nút Phát lệnh thô. Cập nhật tức thời: job.changed cập nhật dòng.
// N11 (05/10/2026): chỉ còn trong Chế độ kỹ thuật — Boss thường mở #/jobs được chuyển sang Lịch sử chạy (chuyen-huong.ts).
import { api, buildQuery, errMsg } from "../api";
import { busy, gen, h } from "../dom";
import { fmtTime, jobCoCanhBao, jobNhanHien, jobStatusTitle, modeTagClass, modeText, modeTitle } from "../format";
import type { Job, Paged } from "../types";
import { uiSocket } from "../ws";
import { ganTenKbChu } from "../ten-kb"; // L-78: hiện TÊN kịch bản thay vì mã kb-…

export async function renderJobs(root: HTMLElement): Promise<() => void> {
  const alive = gen("jobs");
  const tbody = h("tbody", { "data-testid": "job-rows" });
  const more = h("button", { type: "button", hidden: true, title: "Tải thêm 50 lệnh cũ hơn vào bảng", "data-testid": "load-more" }, "Tải thêm");
  const info = h("p", { class: "muted small" }, "Đang tải…");
  root.append(
    h("div", { class: "row between" }, h("h1", {}, "Lệnh chạy"), h("a", { class: "btn pri", href: "#/jobs/new", title: "Chế độ kỹ thuật: mở form phát lệnh thô cho các bot (Boss thường chạy từ trang Kịch bản)" }, "Phát lệnh thô")),
    info,
    h("div", { class: "tbl" }, h("table", {}, h("thead", {}, h("tr", {}, h("th", {}, "Tạo lúc"), h("th", { title: "Kịch bản mà lệnh này chạy" }, "Kịch bản"), h("th", { title: "Chạy thử (bước gửi/đăng/xoá chỉ ghi lại) hoặc Chạy thật" }, "Chế độ"), h("th", { title: "giống nhau = mọi bot cùng tham số; chia đều = một danh sách chia cho các bot" }, "Kiểu"), h("th", { title: "Số bot trong lệnh" }, "Bot"), h("th", {}, "Trạng thái"), h("th", { title: "Số bot đã xong / số bot lỗi" }, "Xong/lỗi"), h("th", {}))), tbody)),
    h("p", {}, more));
  const rows = new Map<string, HTMLTableRowElement>();
  let nextBefore: string | null = null;

  function row(j: Job): HTMLTableRowElement {
    return h("tr", { "data-testid": "job-row", dataset: { id: j.id } },
      h("td", { class: "nowrap small" }, fmtTime(j.createdAt)),
      h("td", { class: "wrap" }, (() => { const a = h("a", { href: `#/jobs/${encodeURIComponent(j.id)}`, title: "Mở chi tiết lệnh này" }, j.spec.bundleName); ganTenKbChu(a, j.spec.bundleName); return a; })()),
      h("td", {}, h("span", { class: modeTagClass(j.spec.mode), title: modeTitle(j.spec.mode) }, modeText(j.spec.mode))),
      h("td", { class: "small" }, j.spec.kind === "chia_deu" ? "chia đều" : "giống nhau"),
      h("td", {}, String(j.summary.total)),
      h("td", {}, h("span", { class: `tag ${jobNhanHien(j).kind}`, title: jobCoCanhBao(j) ? (j.reason ?? "") : jobStatusTitle(j.status) }, jobNhanHien(j).text)),
      h("td", { class: "small", title: "Số bot đã xong / số bot lỗi" }, `${j.summary.done}/${j.summary.failed}`),
      h("td", {}, h("a", { class: "btn mini", href: `#/jobs/${encodeURIComponent(j.id)}`, title: "Mở chi tiết lệnh: từng bot, duyệt, huỷ" }, "Mở")));
  }
  function upsert(j: Job, atTop: boolean): void {
    const fresh = row(j);
    const old = rows.get(j.id);
    if (old) old.replaceWith(fresh);
    else if (atTop) tbody.insertBefore(fresh, tbody.firstChild);
    else tbody.append(fresh);
    rows.set(j.id, fresh);
  }
  async function loadPage(): Promise<void> {
    try {
      const p = await api<Paged<Job>>("GET", `/api/jobs${buildQuery({ limit: 50, before: nextBefore })}`);
      if (!alive()) return;
      for (const j of p.items) upsert(j, false);
      nextBefore = p.nextBefore;
      more.hidden = !nextBefore;
      info.textContent = rows.size ? `${rows.size} lệnh` : "Chưa có lệnh nào. Bấm Phát lệnh mới.";
    } catch (e) {
      if (!alive()) return;
      info.textContent = "";
      root.append(h("div", { class: "err-box", "data-testid": "page-error" }, "Không tải được danh sách lệnh: ", errMsg(e)));
    }
  }
  more.addEventListener("click", () => void busy(more, "Đang tải…", loadPage));
  await loadPage();
  const off = uiSocket.on((ev) => { if (ev.type === "job.changed") upsert(ev.job, true); });
  return off;
}
